<div [formGroup]="zoningCodeForm">
    <mat-form-field>
        <mat-select placeholder="Zoning code" [required]="!isZoningCodeOptional" formControlName="zoningCode">
            <mat-option *ngFor="let zoningCode of getZoningCodes()"
                [value]="zoningCode">{{zoningCode.Name}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
